/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_MisconfiguredInputs */

const en_us2_chat_misconfigured = /** @type {(inputs: Chat_MisconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trainer is not configured in this build.`)
};

const pt_br2_chat_misconfigured = /** @type {(inputs: Chat_MisconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O personal não está configurado nesta versão do app.`)
};

const es_419_chat_misconfigured = /** @type {(inputs: Chat_MisconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El entrenador no está configurado en esta versión de la app.`)
};

const pt_pt2_chat_misconfigured = /** @type {(inputs: Chat_MisconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O treinador não está configurado nesta versão da app.`)
};

const fr_fr2_chat_misconfigured = /** @type {(inputs: Chat_MisconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le coach n'est pas configuré dans cette version de l'appli.`)
};

const de_de2_chat_misconfigured = /** @type {(inputs: Chat_MisconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Coach ist in dieser Version nicht eingerichtet.`)
};

const it_it2_chat_misconfigured = /** @type {(inputs: Chat_MisconfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il coach non è configurato in questa versione dell'app.`)
};

/**
* | output |
* | --- |
* | "The trainer is not configured in this build." |
*
* @param {Chat_MisconfiguredInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const chat_misconfigured = /** @type {((inputs?: Chat_MisconfiguredInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_MisconfiguredInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_chat_misconfigured(inputs)
	if (locale === "es-419") return es_419_chat_misconfigured(inputs)
	if (locale === "pt-PT") return pt_pt2_chat_misconfigured(inputs)
	if (locale === "fr-FR") return fr_fr2_chat_misconfigured(inputs)
	if (locale === "de-DE") return de_de2_chat_misconfigured(inputs)
	if (locale === "it-IT") return it_it2_chat_misconfigured(inputs)
	return en_us2_chat_misconfigured(inputs)
});
export { chat_misconfigured as "chat.misconfigured" }